const live = {
  namespaced: true,
  state: () => {
    return {
      messageList: [],
      user_info: JSON.parse(localStorage.getItem("live_user_info")),
      sign: null,
      webuid: null, // 是否为注册用户
      ws: null,
      token: null,
      acceptGiftList: [], // 接受礼物列表
      total_num: 0, //点赞
      scheduleId: null,
      top_message: "", //置顶消息
      top_teacher_message: "", // 老师置顶消息
      channelId: null, //直播间ID
      startTime: null, //直播开始时间
      historyMessageList: [], //历史消息
      isReadMore: false,
      cmd12Able: true,
      cmd8Able: true,
      fullScreenAble: false,
      nofullScreenAble: false,
      danmuIcon: [], // 弹幕发送Icon
      danmuList: [], // 弹幕列表
      random_danmaku: [], // 随机发送弹幕列表
      player: null
      // token: localStorage.getItem('live_token')
    };
  },
  mutations: {
    addMessage(state, message) {
      state.messageList.push(message);
    },
    addGift(state, message) {
      state.acceptGiftList.push(message);
    },
    addTotal(state, message) {
      state.total_num = message.total_num;
    },
    setScheduleId(state, scheduleId) {
      state.scheduleId = scheduleId;
    },
    setUserInfo(state, info) {
      localStorage.setItem("live_user_info", JSON.stringify(info));
      state.user_info = info;
    },
    setToken(state, token) {
      state.token = token;
    },
    setWebUid(state, webuid) {
      state.webuid = webuid;
    },
    setSign(state, sign) {
      state.sign = sign;
    },
    setWs(state, ws) {
      state.ws = ws;
    },
    addTopMessage(state, message) {
      state.top_message = message;
    },
    addTopTeacherMessage(state, message) {
      state.top_teacher_message = message;
    },
    setChannelId(state, channelId) {
      state.channelId = channelId;
    },
    setStartTime(state, startTime) {
      state.startTime = startTime;
    },
    addHistoryMessageList(state, historyMessageList) {
      state.historyMessageList = historyMessageList;
    },
    // 重新进直播间时清空上一轮聊天数据
    clearMessages(state) {
      state.messageList = [];
      state.historyMessageList = [];
      state.top_message = "";
      state.isReadMore = false;
    },
    setReadMore(state, isReadMore) {
      state.isReadMore = isReadMore;
    },
    setCmd12Able(state, cmd12Able) {
      state.cmd12Able = cmd12Able;
    },
    setCmd8Able(state, cmd8Able) {
      state.cmd8Able = cmd8Able;
    },
    setFullScreen(state, fullScreenAble) {
      state.fullScreenAble = fullScreenAble;
    },
    setNOFullScreen(state, nofullScreenAble) {
      state.nofullScreenAble = nofullScreenAble;
    },
    setDanmuIcon(state, danmuIcon) {
      state.danmuIcon = danmuIcon;
    },
    addDanmu(state, danmu) {
      state.danmuList.push(danmu);
      // 控制弹幕列表长度，避免内存问题
      if (state.danmuList.length > 6) {
        state.danmuList.splice(0, 4);
      }
    },
    setRandomDanmu(state, danmu) {
      state.random_danmaku = danmu;
    },
    setPlayer(state, player) {
      state.player = player;
    }
  },
  actions: {}
};

export default live;
